module.exports = __webpack_public_path__ + "static/media/centro-bazterrica-login.b08bd229.svg";